import type { ReactNode } from 'react';
import { maskTaxId, unmaskTaxId } from '@/shared/lib/tax-id';
import { MaskedInput, type MaskedInputProps } from './masked-input';

/** Props do TaxIdInput: o valor é sempre o CPF/CNPJ sem máscara. */
export type TaxIdInputProps = MaskedInputProps;

/**
 * Campo de CPF ou CNPJ (inclusive alfanumérico): a máscara acompanha o que é digitado e o
 * valor sai sem máscara, em maiúsculas.
 */
export function TaxIdInput({ placeholder = 'CPF ou CNPJ', ...props }: TaxIdInputProps): ReactNode {
  return (
    <MaskedInput
      inputMode="text"
      {...props}
      placeholder={placeholder}
      mask={maskTaxId}
      unmask={unmaskTaxId}
    />
  );
}
